const mutations = {
  setCampaignMaster(state, payload) {
    state.campaignMaster = payload;
  },
  setCustomerMaster(state, payload) {
    state.customerMaster = payload;
  },
  setSoldToCodeLists(state, payload) {
    state.soldToCode = payload;
  },
  setPurposeType(state, payload) {
    state.purposeType = payload;
  },
  setNerpCampaignMaster(state, payload) {
    state.nerpCampingMaster = payload;
  },
  setProductTypeCampaign(state, payload) {
    state.getProductTypeCampaign = payload;
  },
};

export default mutations;